import React from 'react';

const EmptyPage = ({ img, title, text }) => {

	return (
		<div data-testid="empty-history">
			<div className="empty-page">
				<div className="empty-page__img">
					{img}
				</div>
				<h3 className={"h3 empty-page__title"}>{title}</h3>
				<p className={"h3 empty-page__text"}>{text}</p>
			</div>
		</div>
	)
};

export default EmptyPage;
